import PropTypes from 'prop-types';
import React from 'react';

import _ from 'underscore';

import * as SchemaFieldConstants from 'schemas/fields/SchemaFieldConstants';
import * as InventoryFileConstants from 'inventory/InventoryFileConstants';

import HoistedTagNameCell from './HoistedTagNameCell';
import HoistedTagValueCell from './HoistedTagValueCell';

export default function HoistedTagRows(props) {
  const tagSchemaGraphsById = _.indexBy(props.tagSchemaGraphs, 'id');
  const sortedTagsWithGraphs = _.sortBy(props.tags, 'name')
    .map((tag) => ({tag, tagSchemaGraph: tagSchemaGraphsById[tag.tagSchemaGraphId]}))
    // Filter out hoisted tags whose SchemaFieldPath cannot be found, so that they don't hit issues when
    // rendering
    .filter(({tag, tagSchemaGraph}) => tagSchemaGraph);
  return (
    <div>
      {sortedTagsWithGraphs.map(({tag, tagSchemaGraph}, tagIndex) => (
        <div className="simpleDivTable-row metadata-field" key={tagIndex}>
          <HoistedTagNameCell tag={tag} tagSchemaGraph={tagSchemaGraph} />
          <HoistedTagValueCell tag={tag} />
        </div>
      ))}
    </div>
  );
}

HoistedTagRows.propTypes = {
  tags: PropTypes.arrayOf(InventoryFileConstants.HOISTED_TAG.isRequired).isRequired,
  tagSchemaGraphs: PropTypes.arrayOf(SchemaFieldConstants.TAG_SCHEMA_GRAPH.isRequired).isRequired,
};
